import React, { Suspense, useEffect, useRef } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { CONSTANTS } from '../../constants/Constants';
import { ROUTE_CONSTANTS } from '../../constants/RouteConstants';
import { NavigateUserService } from '../../services/navigate-user-service/navigate-user.service';
import { ToasterService } from '../../services/toaster-service/toaster-service';
import { TokenService } from '../../services/token-service/token-service';
import { Loader } from '../ui/loader/Loader';
import { AuthService } from '../../services/auth-service/auth.service';
import Cookies from 'universal-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reduxToolkit/rootReducer';

export const ProtectedRoute: React.FC<{
  component: React.FC;
  path: string;
  exact?: boolean;
}> = (props) => {
  const isMountRef = useRef(false);
  const history = useHistory();
  const { isProjectListOpen, selectedProjectData } = useSelector((state: RootState) => state.ProjectModalData);
  const id = selectedProjectData?.id;

  useEffect(() => {
    isMountRef.current = true;
    if (TokenService().getAccessToken()) {
      const cookies = new Cookies();
      AuthService.userInfo.next(cookies.get('userInfo'));
      const route = new NavigateUserService().getRoute(id);
      if (route) {
        history.push(route);
      } else {
        history.push(ROUTE_CONSTANTS.LOGIN);
        ToasterService.show('Authorization Failure', CONSTANTS.ERROR);
      }
    } else {
      history.push(ROUTE_CONSTANTS.LOGIN);
      ToasterService.show('Authorization Failure', CONSTANTS.ERROR);
    }
    return () => {
      isMountRef.current = false;
    };
  }, [history, id]);

  return isMountRef.current ? (
    <Route
      path={props.path}
      exact={props.exact}
      render={() => (
        <Suspense fallback={<Loader loaderHeight="calc(100vh - 70px)" />}>
          <props.component />
        </Suspense>
      )}
    />
  ) : (
    <Loader />
  );
};
